<template>
  <TripsMarker :coordinates="coordinates" foreground>
    <IconTripsStopOverMarker width="50" height="60" />
  </TripsMarker>
</template>

<script>
import TripsMarker from '@/components/trip-detail/maplib/TripsMarker'
import IconTripsStopOverMarker from '@/components/icons/icon-trips-stopover-marker.svg'

export default {
  components: {
    TripsMarker,
    IconTripsStopOverMarker
  },
  props: {
    coordinates: {
      type: Object,
      required: true,
    }
  },
}
</script>
